import { USE_GRAPHQL_DEMO_DATA } from "@/app/lib/env-helpers";

export const useDemoData = () => {
  return USE_GRAPHQL_DEMO_DATA;
};
